export default function getGapY(value) {
  switch (value) {
    case 0.5:
      return "gap-y-0.5";
    case 1:
      return "gap-y-1";
    case 2:
      return "gap-y-2";
    case 3:
      return "gap-y-3";
    case 4:
      return "gap-y-4";
    case 5:
      return "gap-y-5";
    case 6:
      return "gap-y-6";
    case 7:
      return "gap-y-7";
    case 8:
      return "gap-y-8";
    case 9:
      return "gap-y-9";
    case 10:
      return "gap-y-10";
    case 12:
      return "gap-y-12";
    case 14:
      return "gap-y-14";
    case 16:
      return "gap-y-16";
    case 20:
      return "gap-y-20";
    case 24:
      return "gap-y-24";
    case 28:
      return "gap-y-28";
    case 32:
      return "gap-y-32";
    case 36:
      return "gap-y-36";
    case 40:
      return "gap-y-40";
    case 44:
      return "gap-y-44";
  }
}
